// extracted by mini-css-extract-plugin
module.exports = {"ContinueWithWix":"ContinueWithWixButton_ContinueWithWix__1DPqs","WixLogo":"ContinueWithWixButton_WixLogo__2xTNP"};